<template>
  <div class="lists">
    <div class="list-header"><span>Task Lists</span></div>
    <div v-for="list in lists"
         @click="selectList(list.id)"
         class="list-entry"
         :class="[{selected: list.id === currentListId}, density]"
         :key="list.id">
      {{ list.title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'lists',

  props: [
    'currentListId',
    'updater',
    'density'
  ],

  data () {
    return {
      // A list of {list ID, title} objects.
      lists: [],

      // True if the set of lists is being loaded from the server.
      loading: true
    }
  },

  methods: {
    updateLists: async function () {
      this.loading = true
      this.lists = []
      if (this.$gapi.isLoggedIn()) {
        let accessToken = this.$gapi.getAccessTokenFromLocalStorage()
        if (accessToken !== null) {
          this.updater.waitForFlush()
          this.updater.newSetAccessToken(accessToken)
          this.updater.newListTaskLists(response => {
            for (let list of response.result.items) {
              this.lists.push({ id: list.id, title: list.title })
            }
          })
          this.updater.flush()
        }
      }
      this.updater.waitForFlush()
      let accessToken = this.$gapi.getAccessTokenFromLocalStorage()
      this.updater.newSetAccessToken(accessToken)
      this.updater.flush()
      this.loading = false
    },

    selectList: function (listId) {
      let accessToken = this.$gapi.getAccessTokenFromLocalStorage()
      if (accessToken == null) {
        console.error('Failed to switch list to ' + listId)
        return
      }
      this.updater.waitForFlush()
      this.updater.newSetAccessToken(accessToken)
      this.updater.flush()
      this.$emit('update:currentList', listId)
      this.$emit('closeSidebar')
    }
  },

  mounted () {
    this.$gapi.addAuthStateChangeCallback(this.updateLists.bind(this))
    this.updateLists()
  }
}
</script>

<style scoped>
div.lists {
  width: 100%;
}

div.list-header {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

div.list-header span {
  border-bottom: 1px solid black;
}

span.user-id {
  margin-left: 0.5em;
}

div.list-entry {
  margin-left: 1em;
  cursor: pointer;
  color: #2934d0;
}

div.list-entry:hover, div.list-entry.selected {
  text-decoration: underline;
}

div.list-entry.desktop {
  font-size: 0.85em;
  margin-bottom: 0.5em;
}

div.list-entry.mobile {
  font-size: 1.5em;
  margin-bottom: 1em;
}

</style>
